module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2025-7972be0363778b31aa881ea55b8963e5.svg";